import React from 'react';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

const RkMap = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyBLUV3grT6Ye1BK_DbDthkJaN0qJM8LzIQ&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={8}
    defaultCenter={{ lat: 36.6416459, lng: -93.2166722 }}
  >
    <Marker position={{ lat: 36.6416459, lng: -93.2166722 }} />
  </GoogleMap>
));

export default RkMap;



// WEBPACK FOOTER //
// ./src/components/contact/RkMap.js